/** @jsxImportSource @emotion/react */
import { Buttons } from '@zip/business-components';
import { css } from 'global';
import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as styles from './Spotlight.styles';
import { SpotlightProps } from './SpotlightProps';

const SpotlightModule: FC<SpotlightProps> = ({
  imageUrl,
  text,
  title,
  route,
  targetElementRef,
  setShouldShowSpotlight,
}) => {
  const navigate = useNavigate();

  const [dialogPosition, setDialogPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);

  const dialogWidthInPx = 327;
  const dialogHeightInPx = 160;
  const headerHeightInPx = 56;

  useEffect(() => {
    if (targetElementRef?.current) {
      const menuListItem = targetElementRef.current;
      const rect = menuListItem.getBoundingClientRect();

      // Calculate position to place dialog beside the menu item
      const spacing = 16; // Gap between menu item and dialog

      // Position dialog to the right of the menu item
      const dialogLeft = rect.right + spacing;
      const dialogTop =
        rect.top + rect.height / 2 - dialogHeightInPx / 2 + headerHeightInPx; // Center vertically

      // Check if dialog would go off-screen and adjust if needed
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      let finalLeft = dialogLeft;
      let finalTop = dialogTop;

      // If dialog goes off right edge, position it to the left of menu item
      if (dialogLeft + dialogWidthInPx > viewportWidth) {
        finalLeft = rect.left - dialogWidthInPx - spacing;
      }

      // If dialog goes off bottom edge, adjust top position
      if (dialogTop + dialogHeightInPx > viewportHeight) {
        finalTop = viewportHeight - dialogHeightInPx - spacing;
      }

      // If dialog goes off top edge, adjust top position
      if (finalTop < spacing) {
        finalTop = spacing;
      }

      setDialogPosition({
        top: finalTop,
        left: finalLeft,
      });
    }
  }, [targetElementRef]);

  function open(): void {
    setShouldShowSpotlight(false);
    navigate(route);
  }

  return (
    <>
      <div css={styles.spotlightDialog(dialogPosition, dialogWidthInPx)}>
        <div css={styles.imageContainer(dialogHeightInPx)}>
          <img
            src={imageUrl}
            css={styles.image}
            alt="New feature product & offer"
          />
        </div>
        <div css={styles.textContainer}>
          <p className="heading2" css={css.noTopMrgn}>
            {title}
          </p>
          <p className="body2">{text}</p>
          <div css={styles.newFeatureButton}>
            <Buttons.Primary
              id="newFeature"
              type="submit"
              onClick={(): void => open()}
              style={{ pointerEvents: 'auto' }}
            >
              Open
            </Buttons.Primary>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpotlightModule;
